import { render } from "./Maintenance.vue?vue&type=template&id=86c9555e&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=ts"
export * from "./Maintenance.vue?vue&type=script&lang=ts"

import "./Maintenance.vue?vue&type=style&index=0&id=86c9555e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-86c9555e"
/* hot reload */
if (module.hot) {
  script.__hmrId = "86c9555e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('86c9555e', script)) {
    api.reload('86c9555e', script)
  }
  
  module.hot.accept("./Maintenance.vue?vue&type=template&id=86c9555e&scoped=true", () => {
    api.rerender('86c9555e', render)
  })

}

script.__file = "common/src/views/Maintenance.vue"

export default script